import { translate } from '../i18n/I18nProvider';
import Optional from './optional';

export default function findTranslatedValues(value, valuesObject = {}) {
  return Optional(valuesObject[value])
    .map(intlValue => translate(intlValue))
    .or(value);
}
